module.exports = __webpack_public_path__ + "static/img/web_pg_1.183ca8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web_pg_1.jpg
// module id = NhlR
// module chunks = 1